import { configureStore } from "@reduxjs/toolkit";
import postSlice from "./reducers/post";
import userSlice from "./reducers/user";
export const store = configureStore({

    reducer: {
        posts: postSlice,
        users:userSlice
    }
})